import { useTranslation } from 'react-i18next';

export default function useTableStatusMessages() {
  const { t } = useTranslation(['table']);

  const errorProps = {
    title: t('error.title', { ns: 'table' }),
    description: t('error.description', { ns: 'table' }),
  };

  const emptyProps = {
    title: t('empty.title', { ns: 'table' }),
    description: t('empty.description', { ns: 'table' }),
  };

  return { errorProps, emptyProps };
}
